import React, { createContext, useState, ReactNode } from 'react'

interface ThemeModeContextProps {
  mode: string
  toggleMode: (mode: string) => void
}

export const ThemeModeContext = createContext<ThemeModeContextProps | undefined>(undefined);

export const ThemeModeProvider = ({ children, initialMode }: { children: ReactNode, initialMode: string|undefined }) => {
  const [mode, setMode] = useState(initialMode || 'light')

  const toggleMode = (mode: string) => {
    setMode(mode)
  }

  return (
    <ThemeModeContext.Provider value={{ mode, toggleMode }}>
      {children}
    </ThemeModeContext.Provider>
  )
}
